import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { adminApi, errMsg, fmt, fmtDate } from "@/lib/api";

const EditUser = ({ u, onClose, onSaved }) => {
  const [balance, setBalance] = useState(String(u.balance));
  const [queue, setQueue] = useState((u.forced_queue || []).join(", "));
  const [banned, setBanned] = useState(!!u.banned);
  const save = async () => {
    try {
      const forced_queue = queue.split(/[,\s]+/).map((x) => x.replace(",", ".")).filter(Boolean).map(Number).filter((x) => !isNaN(x));
      const { data } = await adminApi.put(`/admin/users/${u.id}`, { balance: Number(balance), forced_queue, banned });
      toast.success("Kullanıcı güncellendi");
      onSaved(data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="bg-[var(--x-bg)] border-[var(--x-border)]" data-testid="edit-user-dialog">
        <DialogTitle className="font-extrabold">{u.username}</DialogTitle>
        <DialogDescription className="text-[var(--x-muted)] text-sm">Bakiye, özel çarpan sırası ve hesap durumu</DialogDescription>
        <div className="space-y-4">
          <div>
            <label className="x-label">Bakiye (₺)</label>
            <input data-testid="edit-user-balance-input" type="number" className="x-input" value={balance} onChange={(e) => setBalance(e.target.value)} />
          </div>
          <div>
            <label className="x-label">Sıradaki Çarpanlar (kullanıcıya özel)</label>
            <input data-testid="edit-user-queue-input" className="x-input font-mono" placeholder="örn: 1.20 4 1.50 2.30" value={queue} onChange={(e) => setQueue(e.target.value)} />
            <div className="text-[12px] text-[var(--x-dim)] mt-1">Boşlukla ayırın. Kullanıcının sonraki bahisleri sırayla bu çarpanlarla sonuçlanır, bitince olasılık tablosu devreye girer.</div>
          </div>
          <div className="flex items-center justify-between">
            <span className="font-bold">Hesabı Askıya Al</span>
            <Switch data-testid="edit-user-ban-switch" checked={banned} onCheckedChange={setBanned} />
          </div>
          <button data-testid="edit-user-save-btn" onClick={save} className="x-btn x-btn-primary w-full">Kaydet</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const AdminUsers = () => {
  const [q, setQ] = useState("");
  const [users, setUsers] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => adminApi.get("/admin/users", { params: { q } }).then((r) => setUsers(r.data));
  useEffect(() => {
    const t = setTimeout(load, 300);
    return () => clearTimeout(t);
  }, [q]); // eslint-disable-line react-hooks/exhaustive-deps
  const byId = Object.fromEntries(users.map((u) => [u.id, u.username]));

  return (
    <div className="x-panel p-4">
      <input data-testid="admin-user-search" className="x-input max-w-sm mb-4" placeholder="Kullanıcı ara..." value={q} onChange={(e) => setQ(e.target.value)} />
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[var(--x-muted)]">
            <th className="px-3 py-2">Kullanıcı</th><th className="px-3 py-2 text-right">Bakiye</th><th className="px-3 py-2 text-right">Ortaklık</th>
            <th className="px-3 py-2">Davet Eden</th><th className="px-3 py-2">Özel Sıra</th><th className="px-3 py-2">Kayıt</th><th className="px-3 py-2" />
          </tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-white/5" data-testid={`admin-user-row-${u.username}`}>
                <td className="px-3 py-2.5 font-bold">{u.username} {u.banned && <span className="x-chip bg-[var(--x-red)]/20 text-[var(--x-red)] ml-1">Askıda</span>}</td>
                <td className="px-3 py-2.5 text-right tabular-nums">₺{fmt(u.balance)}</td>
                <td className="px-3 py-2.5 text-right tabular-nums">₺{fmt(u.affiliate_balance)}</td>
                <td className="px-3 py-2.5 text-[var(--x-muted)]">{u.referred_by ? byId[u.referred_by] || "✓" : "-"}</td>
                <td className="px-3 py-2.5 font-mono text-[12px]">{(u.forced_queue || []).join(" ") || "-"}</td>
                <td className="px-3 py-2.5 text-[var(--x-muted)]">{fmtDate(u.created_at)}</td>
                <td className="px-3 py-2.5 text-right">
                  <button data-testid={`admin-user-edit-${u.username}`} onClick={() => setEdit(u)} className="x-btn x-btn-secondary px-3 py-1.5 text-[13px]">Düzenle</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {edit && <EditUser u={edit} onClose={() => setEdit(null)} onSaved={(d) => { setUsers(users.map((x) => (x.id === d.id ? d : x))); setEdit(null); }} />}
    </div>
  );
};
